@if (permsService?.perms?.administrative) {
	<div class="calendar-wrap time-allocation">
		<div class="calendar-above-row cal-vers">
			<div
				class="flex-center"
				style="flex-grow: 1"
			>
				<h2 class="cal-title">{{ "time_allocation" | langVal }}</h2>
			</div>

			@if (permsService?.owner_has_users) {
				@if (permsService?.perms?.all_patients_all_fus) {
					<div style="width: 200px">
						<app-autocomplete-with-tags
							(chosenEvent)="chooseTags($event)"
							title_ph_lang="filter_sub_users"
							hasPlus
						/>
					</div>
					<div
						class="flex-v-center"
						style="margin-bottom: 1px"
					>
						<button
							class="cal-btn"
							(click)="subUserMove(-1)"
						>
							&lt;
						</button>
						<app-gen-autocomplete
							#subUsersFuzzy
							title_ph_lang="sub_user"
							[fuzzySearchableClasses]="['sub_users']"
							[approvedIds]="subUserIds"
							(chosenEvent)="subUsersClick($event)"
						/>
						<button
							class="cal-btn"
							(click)="subUserMove(1)"
						>
							&gt;
						</button>
					</div>
				}
				<div class="flex">
					<button
						class="cal-btn"
						routerLink="/calendar/"
					>
						{{ "calendar" | langVal }}
					</button>

					@if (currentView == "listWeek") {
						<button
							class="cal-btn btn-primary"
							(click)="changeView('timeGridWeek')"
						>
							{{ "calendar_view" | langVal }}
						</button>
					} @else {
						<button
							class="cal-btn btn-primary"
							(click)="changeView('listWeek')"
						>
							{{ "list_view" | langVal }}
						</button>
					}
				</div>
			} @else {
				<div>
					<button
						class="cal-btn"
						titleLang="meetingtypes"
						(click)="modalProps = { name: 'table-display-meetingtypes' }"
					>
						{{ "meetingtypes" | langVal }}
					</button>
				</div>
				<div>
					<button
						class="cal-btn"
						titleLang="time_allocations"
						(click)="
							modalProps = { name: 'table-display-solo-time-allocations' }
						"
					>
						{{ "time_allocations" | langVal }}
					</button>
				</div>
			}
		</div>
		<full-calendar
			#calendar
			[deepChangeDetection]="true"
			[options]="calendarOptions"
		/>
	</div>
}
@switch (modalProps?.name) {
	@case ("time-allocation-form") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			modalWrapperClass="modal-small-width"
			title="time_allocation"
		>
			<app-time-allocation-form
				(onClose)="modalProps = null; handleformClose($event)"
				[events]="events"
				[isUpdateMode]="modalProps.isUpdateMode"
				[insertObj]="modalProps.insertObj"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-meetingtypes") {
		<app-modal-wrap
			(onClose)="modalProps = null; getApiKeys()"
			modalWrapperClass="modal-wide"
			title="meetingtypes"
		>
			<app-gen-table-display
				(onClose)="modalProps = null; getApiKeys()"
				tableName="meetingtypes"
				[overrideUpperFields]="[
					'name',
					'price',
					'length',
					'first_time_meeting_request',
					'return_meeting_request',
				]"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-solo-time-allocations") {
		<app-modal-wrap
			(onClose)="modalProps = null; handleSoloTimeAllocationsClose()"
			title="solo_time_allocations"
		>
			<app-gen-table-display
				(onClose)="modalProps = null; handleSoloTimeAllocationsClose()"
				tableName="solo_time_allocations"
			/>
		</app-modal-wrap>
	}
}
